<template>
  <v-layout>
    <Navs />
    <AppBar />

    <v-main
      height="auto"
      style="position: relative; overflow-y: auto"
    >
      <v-container fluid class="pa-0">
        <router-view />
      </v-container>
    </v-main>
  </v-layout>
</template>

<script>
import Navs from "../components/Navbar/Navs.vue";
import AppBar from "../components/AppBar/AppBar.vue";
export default {
  name: "App",
  components: {
    Navs,
    AppBar,
  },
  data() {
    return {
      drawer: true, // State for the sidebar
    };
  },
  method: {},
};
</script>

<style>
/* Add additional styling if needed */
</style>
